import TopReview from '@/widgets/TopReview';
import MiniTopReview from '@/widgets/TopReview/mini.vue';
import CommentCount from '@/widgets/CommentCount/index.vue';
import NotificationsDropdown from '@/widgets/Notifications/Dropdown';
import DropdownProfilePage from '@/widgets/DropdownProfilePage';
import Leaderboards from '@/widgets/Leaderboards';
import SocialFeed from '@/widgets/SocialFeed';
import RecentImagesGrid from '@/widgets/RecentImagesGrid/index.vue';
import ProductRating from '@/widgets/ProductRating';
import CompactLeaderboard from '@/widgets/CompactLeaderboard';
import MyCompactProfileCard from '@/widgets/MyCompactProfileCard';
import ActiveMembersGrid from '@/widgets/ActiveMembersGrid';
import StartPageSlideshow from '@/widgets/StartPageSlideshow';
import MyAvatarThumbnail from '@/widgets/MyAvatarThumbnail';
import NewCommentsSlideshow from '@/widgets/NewCommentsSlideshow';
import AchievementList from '@/widgets/AchievementList';
import PinnedPost from '@/widgets/PinnedPost';
import NotificationList from '@/widgets/Notifications/List';
import TutorialModal from '@/widgets/Tutorial';
import TestWidget from '@/widgets/TestWidget';
import CategoryProductRecommendations from '@/widgets/CategoryProductRecommendations';
import CommentSection from '@/widgets/CommentSection';
import MyAvatarFullBody from '@/widgets/MyAvatarFullbody';
import MyProfileStats from '@/widgets/MyProfileStats';
import MyProfileStatsExpanded from '@/widgets/MyProfileStatsExpanded';
import MyCustomerLevel from '@/widgets/MyCustomerLevel';
import MyCustomerName from '@/widgets/MyCustomerName';
import MyCustomerPills from '@/widgets/MyCustomerPills';
import UploadGrid from '@/widgets/UploadGrid';
import ReviewSummary from '@/widgets/ReviewSummary';

import { defineAsyncComponent } from 'vue';

const CommentList = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/widgets/CommentList');
});
const QuestList = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/QuestList');
});

const CustomerAttributeEditor = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/CustomerAttributeEditor');
});

const CustomerCard = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/CustomerCard');
});

const AvatarConfigurator = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "avatar-3d" */'@/components/AvatarConfigurator');
});

import Avatar from '@/components/Avatar';

import createProfileCard from '@/widgets/ProfileCard/createProfileCard';
import { createAvatarConfigurator } from '@/legacy/avatar-configurator';

import { elAttach } from '@/utils/elAttach';

import { createApp } from 'vue';

import state from '@/state';

import OrderedProductList from '@/components/OrderedProductList';

import SiteReviewBanner from '@/widgets/SiteReviewBanner';

function removeUndefined(obj) {
  for (const k in obj) {
    if (obj[k] === undefined) {
      delete obj[k];
    }
  }
  return obj;
}

/*
*
* Widgets definitions
* use this instead of manual elAttach
*
*/
const widgets = {
  'gmf-site-review-banner': {
    component: SiteReviewBanner,
    selector: '.gmf-site-review-banner',
  },
  'gmf-new-comments-slideshow': {
    component: NewCommentsSlideshow,
    selector: '.gmf-new-comments-slideshow',
    props: {
      commentType: 'data-comment-type',
    },
  },
  'gmf-start-page-slideshow': {
    component: StartPageSlideshow,
    selector: '.gmf-start-page-slideshow',
  },
  'gmf-notifications': {
    component: NotificationList,
    selector: '.gmf-notifications',
  },
  'gmf-test-widget': {
    component: TestWidget,
    selector: '.gmf-test-widget',
  },
  'gmf-comment-section': {
    component: CommentSection,
    selector: '#gmf-comment-section',
    props: {
      targetId: 'data-product-id',
      commentTypes: 'data-comment-types',
      defaultTab: 'data-default-tab',
      mockJson: 'data-mock-json',
    },
  },
  'gmf-pinned-post': {
    component: PinnedPost,
    selector: '.gmf-pinned-post',
  },
  'gmf-tutorial-modal': {
    component: TutorialModal,
    selector: '.gmf-tutorial-modal',
  },
  'gmf-ordered-product-list': {
    component: OrderedProductList,
    selector: '.gmf-ordered-product-list',
  },

  'gmf-my-compact-profile-card': {
    component: MyCompactProfileCard,
    selector: '.gmf-my-compact-profile-card',
  },
  'gmf-widget-customer-attribute-editor': {
    component: CustomerAttributeEditor,
    selector: '.gmf-widget-customer-attribute-editor',
  },
  'gmf-my-content': {
    component: CommentList,
    selector: '#gmf-my-content',
  },
  'gmf-leaderboards': {
    component: Leaderboards,
    selector: '#gmf-leaderboards',
  },
  'gmf-notification-dropdown': {
    component: NotificationsDropdown,
    selector: '#gmf-notification-dropdown',
  },
  'gmf-my-avatar-thumbnail': {
    component: MyAvatarThumbnail,
    selector: '.gmf-my-avatar-thumbnail',
  },
  'gmf-my-avatar-fullbody': {
    component: MyAvatarFullBody,
    selector: '.gmf-my-avatar-fullbody',
  },
  'gmf-my-profile-stats': {
    component: MyProfileStats,
    selector: '.gmf-my-profile-stats',
  },
  'gmf-my-profile-stats-expanded': {
    component: MyProfileStatsExpanded,
    selector: '.gmf-my-profile-stats-expanded',
  },
  'gmf-my-profile-pills': {
    component: MyCustomerPills,
    selector: '.gmf-my-profile-pills',
  },
  'gmf-my-customer-name': {
    component: MyCustomerName,
    selector: '.gmf-my-customer-name',
  },
  'gmf-my-customer-level': {
    component: MyCustomerLevel,
    selector: '.gmf-my-customer-level',
  },
  'gmf-social-feed': {
    component: SocialFeed,
    selector: '.gmf-social-feed',
    props: {
      defaultBoardId: 'data-board-id',
      defaultCommentType: 'data-comment-type',
    },
  },
  'gmf-active-members-grid': {
    component: ActiveMembersGrid,
    selector: '.gmf-active-members-grid',
  },
  'gmf-recent-images-grid': {
    component: RecentImagesGrid,
    selector: '.gmf-recent-images-grid',
  },
  'gmf-product-rating': {
    component: ProductRating,
    selector: '.gmf-product-rating',
    props: {
      productId: 'data-product-id',
      compact: 'data-compact',
      mockJson: 'data-mock-json',
      size: 'data-size',
    },
  },
  'gmf-dropdown-profile-old': {
    component: DropdownProfilePage,
    selector: '#gmf-dropdown-profile',
  },
  'gmf-dropdown-profile': {
    component: DropdownProfilePage,
    selector: '.gmf-dropdown-profile',
  },
  'gmf-category-product-recommendations': {
    component: CategoryProductRecommendations,
    selector: '.gmf-category-product-recommendations',
    props: {
      categoryId: 'data-category-id',
    },
  },
  'gmf-mini-top-review': {
    component: MiniTopReview,
    selector: '.gmf-mini-top-review',
    props: {
      productId: 'data-product-id',
    },
  },
  'gmf-top-review': {
    component: TopReview,
    selector: '.gmf-top-review',
    props: {
      productId: 'data-product-id',
      mockJson: 'data-mock-json',
    },
  },
  'gmf-comment-count': {
    component: CommentCount,
    selector: '.gmf-comment-count',
    props: {
      productId: 'data-product-id',
    },
  },
  'gmf-quest-list': {
    component: QuestList,
    selector: '.gmf-widget-quest-list',
  },
  'gmf-achievement-list': {
    component: AchievementList,
    selector: '#gmf-achievement-list',
    props: {
      displayMode: 'data-display-mode',
    },
  },
  'gmf-test-profile-card': {
    component: CustomerCard,
    selector: '.gmf-test-profile-card',
    props: {
      merchantCustomerId: 'data-merchant-customer-id',
    },
    provide: {
      modalState: { isTopModal: true },
    }
  },
  'gmf-avatar-3d-configurator': {
    component: AvatarConfigurator,
    selector: '.gmf-avatar-3d-configurator',
    props: {
      hideCancelButton: 'data-hide-cancel-button',
      hideSaveButton: 'data-hide-save-button',
      saveText: 'data-save-text',
    }
  },
  'gmf-upload-grid': {
    component: UploadGrid,
    selector: '.gmf-upload-grid',
  },
  'gmf-review-summary': {
    component: ReviewSummary,
    selector: '.gmf-review-summary',
    props: {
      productId: 'data-product-id',
    },
  },
};

for (const widget in widgets) {
  elAttach(widgets[widget].selector, async function (el) {
    const props = {};
    if (widgets[widget].props) {
      for (const prop in widgets[widget].props) {
        if (el.hasAttribute(widgets[widget].props[prop])) {
          props[prop] = el.getAttribute(widgets[widget].props[prop]);
        }
      }
    }

    const app = createApp(widgets[widget].component, props);

    if (widgets[widget].provide) {
      for (const key in widgets[widget].provide) {
        app.provide(key, widgets[widget].provide[key]);
      }
    }

    app.mount(el);
  });
}

elAttach('#gmf-profile-card', async function (el) {
  createProfileCard(removeUndefined({
    selector: el,
    name: el.getAttribute('data-name'),
    achievementPageUrl: el.getAttribute('data-achievement-list-url') || undefined,
    avatarEditorUrl: el.getAttribute('data-avatar-editor-url') || undefined,
  }));
});

elAttach('.gmf-compact-leaderboard', async function (el) {
  createApp(CompactLeaderboard)
    .provide('injectedLeaderboard', el.getAttribute('data-leaderboard'))
    .mount(el);
});

elAttach('#gmf-avatar-configurator', async function (el) {
  createAvatarConfigurator({
    selector: el,
  });
});

elAttach('.gmf-avatar', async function (el) {
  const customerId = el.getAttribute('data-customer-id');
  if (!customerId) {
    throw new Error('Missing required attribute data-customer-id');
  }

  // @TODO perhaps we'd like to fetch avatars from the api instead
  const avatarUrl = state.cdnBase + '/v2/avatar/headshot/' + state.merchantId + '/' + customerId;

  const customer = {
    id: customerId,
    avatarUrl: el.getAttribute('data-avatar-url') || avatarUrl,
  };

  createApp(Avatar, {
    customer,
  })
    .mount(el)
});
